/*
@file-overview 

- These methods were taken from AEM WCAX repos

- The methods were copied into this file and cleaned up to work within other 
    consuming applications

*/
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { UserInfoService } from './user-info.service';
import { EventTracking } from '../public-api';

// jQuery
declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  // is local storage enabled flag
  public _isLSEnabled : any = undefined;

  constructor(private _configService: ConfigService, private _userInfoService : UserInfoService ) {}

  public isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

  public getCookie(cname) {
    let cvalue = '';
    // check if cookie is enabled
    if (this.isCookieEnabled()) {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                cvalue = c.substring(name.length, c.length);
            }
        }
    }
    else {
        const cookiesStorage = this._configService.getCookiesConfig().cookiesStorage;
        const cookie = cookiesStorage[cname];
        if (typeof cookie != 'undefined' && this.hasTimeExpired(cookie['expires']) == false) {
            cvalue = decodeURIComponent(cookie['value']);
        }
    }

    return cvalue;
  }

  public setCookie(cname, cvalue, exdays, isOktaExpiration) {
    const d = new Date();
    let expires = '';
    let isOkta = false;
    
    if (isOktaExpiration && isOktaExpiration === 'true'){
      expires = exdays;
      isOkta = true;
    } else {
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      expires = 'expires=' + d.toUTCString();
    }
    // check if cookie is enabled
    if (this.isCookieEnabled()) {
        if (exdays > 0 || isOkta) {
            if(this.tagCookiesSecure()){
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure;";
            }
            else{
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            }
        }
        else {
            if(this.tagCookiesSecure()){
                document.cookie = cname + "=" + cvalue + ";path=/;secure;";
            }
            else {
                document.cookie = cname + "=" + cvalue + ";path=/";
            }
        }
    }
    else {
      const cookiesStorage = this._configService.getCookiesConfig().cookiesStorage;
      cookiesStorage[cname] = {'value': cvalue, 'expires': d.toUTCString()};
    }
  }

  private isCookieEnabled = function() {
    let isEnabled = (navigator.cookieEnabled) ? true : false;

    // if not IE4+ nor NS6+
    if (typeof navigator.cookieEnabled == 'undefined' && !isEnabled) {
        document.cookie = 'testcookie';
        isEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
    }

    // return to see if cookie is enabled from browser
    return isEnabled;
  }

  private hasTimeExpired(expiry) {
    let hasExpired = false;
    let currentTime = null;
    let expiryTime = null;

    try {
        if (expiry) {
              currentTime = (new Date()).getTime();
              expiryTime = new Date(expiry).getTime();
              hasExpired = currentTime > expiryTime;
        }
    }
    catch (e) {
        hasExpired = true;
    }

    return hasExpired;
  }

  private tagCookiesSecure() {
    const cookiesSecureFlag = this._configService.getCookiesConfig().cookiesSecureFlag;
    return (typeof cookiesSecureFlag !== "undefined" && cookiesSecureFlag !== null &&
        cookiesSecureFlag !== '' && cookiesSecureFlag === 'false' ) ? false : true;
  }

  public isLSEnabled() {
    return this._isLSEnabled;
  }

  public setIsLSEnabled(enabled) {
    this._isLSEnabled = enabled;
  }
  
  public isLSCompatible () {
    const test = 'test';
    try {
        if (typeof this.isLSEnabled() == 'undefined') {
            localStorage.setItem ( test, test );
            localStorage.removeItem ( test );
            console.log ( '==== LOCAL STORAGE IS ENABLED ====' );
            this.setIsLSEnabled(true);
        }
    } catch ( e ) {
        console.log ( '==== LOCAL STORAGE IS DISABLED ====' );
        this.setIsLSEnabled(false);
    }
    return this.isLSEnabled();
  }

  //-----------------------------------------------------------------------------------------------------

    /*
        DFTA - methods for user session status checking
    */


  public checkAuthorizedCookie = function () {
    const strSharedSession = this.getCookie('SWY_SHARED_SESSION_INFO');
    let result = false;
    let objSharedSession = {};
    try {
        if (strSharedSession) {
            objSharedSession = JSON.parse(strSharedSession);

            result = (typeof objSharedSession == "object") ? true : false;
        }
    }
    catch (e) {
        result = false;
    }
    return result;
  };

  public updateTokenRefreshProperty = function() {
    let sharedInfo = this.getCookie('SWY_SHARED_SESSION_INFO');

    if (sharedInfo != "") {
        sharedInfo = decodeURI(sharedInfo);
        sharedInfo = JSON.parse(sharedInfo);

        if(!this.isEmpty(sharedInfo.info)) {
            if (!this.isEmpty(sharedInfo.info.SHOP)) {
                const shopSharedInfo = sharedInfo.info.SHOP;
                const userType = (shopSharedInfo.userType !== undefined) ? shopSharedInfo.userType : '';

                const newSession = {
                    ...this._userInfoService.getUserSession(),
                    userType : userType
                }

                if (shopSharedInfo.userData) {
                    const expireTime = (shopSharedInfo.userData.expireTime !== undefined) ? shopSharedInfo.userData.expireTime : '';
                    newSession['expireTime'] = expireTime;
                }

                this._userInfoService.setUserSession(newSession);
            }
        }
    }
  }

  /**
     * Check if user is still logged in.
     */
    public isTokenActive = function () {
      // declare function variable(s)
      let currentTime = null;
      let expireTime = null;
      let isTokenActive = false;

      if ( this._userInfoService.getExpireTime() ) {
          currentTime = (new Date()).getTime();
          expireTime = parseInt(this._userInfoService.getExpireTime());
          if (expireTime > currentTime) {
              isTokenActive = true;
          }
      }

      return isTokenActive;
  };

  /**
     * This method will return the url query param value.
     * @param {string} params - The query param that needs to be returned.
    **/

   public getParams(params) {
        const param = new URLSearchParams(window.location.search);
        return param.get(params) ? param.get(params) : null;
    }

    /**
     * Returns the queryParam string for GR Search
     * @param {string} channel 
     * @returns {string} 
     * 
     * @memberOf UtilService
     */
    public getGRSearchParams(channel: string): string {
        let fqParam = '&fq=inventoryAvailable:"1"OR"2"';
        if (window['analyticsSwy']?.testFlags?.EOT3079) {
            if (channel === 'pickup') {
                fqParam = '&fq=pickupInventory:"1"OR"2"';
            } else if (channel === 'delivery') {
                fqParam = '&fq=deliveryInventory:"1"OR"2"';
            }
            fqParam += '&variant=' + window['analyticsSwy']?.testFlags?.EOT3079?.toLowerCase();
            if (window['AB']['COMMON'].getCookie('absVisitorId')) {
              fqParam += '&visitorId=' + window['AB']['COMMON'].getCookie('absVisitorId');
            }
            if (window['AB']['userInfo']['UUID']) {
              fqParam += '&uuid=' + window['AB']['userInfo']['UUID'];
            }
        }
        return fqParam;
    }

    //----------------------------------------------------------------------------
    /**
     * Gets an optional HTML element reference by selector.
     *
     * @param  name  element name/selector
     * @return HTML element reference, null if not found
     */
    //----------------------------------------------------------------------------
    public readElement(name) 
    {
        const $element = $(name);
        if ($element && $element.length) return $element;

        return null;
    } // readElement

     //----------------------------------------------------------------------------
     /**
      * Gets an first optional HTML element reference by selector.
      *
      * @param  name  element name/selector
      * @return HTML element reference, null if not found
      */
     //----------------------------------------------------------------------------
     public readOneElement(name)
     {
         const $element = $(name);
         if ($element && $element.length) return $element[0];

         return null;
     } // readOneElement

    //----------------------------------------------------------------------------
    /**
     * Gets a mandatory HTML element reference by selector.
     *
     * @param  name  element name/selector
     * @return HTML element reference, never null
     */
    //----------------------------------------------------------------------------
    public getElement(name)
    {
        const $element = this.readElement(name);
        if ($element === null)
        {
            throw new Error("Cannot find element: " + name);
        }

        return $element;
    } // getElement

    //----------------------------------------------------------------------------
    /**
     * Gets a mandatory meta content attribute reference by selector.
     *
     * @param  name  meta name/selector
     * @return HTML meta content attribute, never null
     */
    //----------------------------------------------------------------------------
    public getMetaElementContent(name)
    {
        const $element = $('meta[name=' + name + ']');            
        if ($element === null)
        {
            throw new Error("Cannot find element: " + name);
        }

        return $element.attr('content');;
    } 

    public nativeFind(collection: Array<any>, eventTracking: EventTracking): any {
        let matchingItem = undefined;
        if (typeof eventTracking != 'object') return undefined;

        collection.forEach(item => {
            if (this.matches(item, eventTracking)) {
                matchingItem = item;
            }
        })

        return matchingItem;
    }
    
    // Determines partial equality between two objects. 
    // Object 1 must partially equal object 2, i.e it contains at least all the properties object 2 contains. 
    private matches(object1, object2) {
        for (const key in object2) {
          if (object2.hasOwnProperty(key)) {
            if (typeof object2[key] === 'object' && object2[key] !== null) {
              if (!this.matches(object1[key], object2[key])) {
                return false;
              }
            } else {
              if (!object1.hasOwnProperty(key) || object1[key] !== object2[key]) {
                return false;
              }
            }
          }
        }
        return true;
    }

}
